const MediaGrid = ({ rawData }) => {
    if (!rawData) return null;

    const getImgSrc = (pic) => (pic?.startsWith("http") ? pic : "/upload/" + pic);

    let mediaList = [];
    try {
        if (Array.isArray(rawData)) {
            mediaList = rawData;
        } else if (typeof rawData === 'string') {
            mediaList = rawData.startsWith("[") ? JSON.parse(rawData) : [rawData];
        }
    } catch (err) {
        mediaList = [rawData];
    }

    if (mediaList.length === 0) return null;

    const displayImages = mediaList.slice(0, 4);
    const remainingCount = mediaList.length - 4;
    const gridClass = `grid-${Math.min(mediaList.length, 4)}`;

    return (
        <div className={`media-grid-preview ${gridClass}`}>
            {displayImages.map((imgSrc, index) => {
                const finalSrc = getImgSrc(imgSrc);
                const isVideo = finalSrc?.match(/\.(mp4|webm|ogg)$/i);
                const isLastItem = index === 3 && remainingCount > 0;

                return (
                    <div className={`media-item ${isLastItem ? "overlay-container" : ""}`} key={index}>
                        {isVideo ? (
                            <video src={finalSrc} muted className="preview-media" />
                        ) : (
                            <img src={finalSrc} alt="" className="preview-media" />
                        )}
                        
                        {isLastItem && (
                            <div className="overlay-count">
                                +{remainingCount}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default MediaGrid;